var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.user)?_c('edit-user-form',{attrs:{"user":_vm.user}}):_vm._e()],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }